
import React, { useEffect } from 'react'
import { Container, Header, Icon, Menu, Label, Divider } from 'semantic-ui-react'
import AboutAccommodation from '../../../components/AboutAccommodation/AboutAccommodation';
import { useTranslation } from "react-i18next";
import AccommodationRooms from '../../../components/AccommodationRooms/AccommodationRooms';
import AccommodationBathrooms from '../../../components/AccommodationBathrooms/AccommodationBathrooms';
import AccommodationFacilities from '../../../components/AccommodationFacilities/AccommodationFacilities';
import AccommodationAvailableDates from '../../../components/AccommodationAvailableDates/AccommodationAvailableDates';

import "./Section2.css"

const Section2 = ({ fixed }) => {
    const { t } = useTranslation();


    return (<Container className="bg-white PropertySection2" >
        <Menu className={`m-5-t bg-white ${fixed ? "d-block" : "d-none"}`} secondary  fixed={fixed ? 'top' : null} >
            <Container>
                <Menu.Item
                    as="a"
                    href="#property-section1"
                    name={t("property:Photos")}
                />
                <Menu.Item
                    as="a"
                    href="#amenities"
                    name={t("property:Amenities")}
                />
                <Menu.Item
                    as="a"
                    href="#property-section3"
                    name={t("property:Reviews")}
                />
                <Menu.Item
                    as="a"
                    href="#location-section"
                    name={t("property:Location")}
                />
            </Container>
        </Menu>

        <Header as='h3'>{t("property:Host")} : فرناز عبداللهی</Header>
        <Label basic className="border-none">
            10 {t("property:Guests")}
        </Label>
        .
        <Label basic as='a' className="border-none">
            5 {t("property:Bedrooms")}
        </Label>
        .
        <Label basic className="border-none">
            10 {t("property:Beds")}
        </Label>
        .
        <Label basic as='a' className="border-none">
            5 {t("property:Baths")}
        </Label>
        <Divider />
        <Header as='h4'>
            <Icon name="building outline" />
            <Header.Content>
                {t("property:SelfCheckin")}
                <Header.Subheader>
                    {t("property:CheckYourselfInWithTheLockbox")}
                </Header.Subheader>
            </Header.Content>
        </Header>
        <Header as='h4'>
            <Icon name='calendar outline' />
            <Header.Content>
                {t("property:FreeCancellationFor48Hours")}
                <Header.Subheader>
                </Header.Subheader>
            </Header.Content>
        </Header>
        <Header as='h4'>
            <Icon name='group' />
            <Header.Content>
                5 نفر ظرفیت استاندارد + 2 نفر اضافه
                <Header.Subheader>
                    هزینه هر نفر اضافه 70٫000 تومان
                </Header.Subheader>
            </Header.Content>
        </Header>

        <Divider />
        <AboutAccommodation />
        <Divider />
        <AccommodationRooms/>
        <Divider />
        <AccommodationBathrooms/>
        <Divider />
        <AccommodationFacilities/>
        <Divider/>
        <AccommodationAvailableDates/>
    </Container>

    )
}
export default Section2